webpackJsonp([1,6,11],{

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(59),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(58),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(89),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      users: [],
      searchText: ''
    };
  },

  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      return this.users.filter(function (user) {
        return user.name.toLowerCase().match(_this.searchText.toLowerCase());
      });
    }
  },
  methods: {
    pushProfile: function pushProfile(id) {
      this.$router.push('/profile/' + id);
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'contacts': doc.data().contacts
        };
        if (user.name != null && user.id !== _this2.$store.getters.user.id) {
          _this2.users.push(user);
        }
      });
    });
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from '../../Firebase/FirebaseInit'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notifications: Array
  },
  computed: {
    sortedNotifications: function sortedNotifications() {
      return this.notifications.sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });
    }
  },
  methods: {
    readMessages: function readMessages() {
      for (var i = 0; i < this.notifications.length; i++) {
        if (!this.notifications[i].read) {
          console.log(this.notifications[i]);
          this.notifications[i].read = true;
          this.$store.dispatch('readNotification', { user: this.$store.getters.user.id, notification: this.notifications[i].id });
        }
      }
    },
    respond: function respond(notification, accepted) {
      var timestamp = new Date().getTime();

      var message = this.$store.getters.user.name + ' has accepted your follow request!';
      if (!accepted) {
        message = this.$store.getters.user.name + ' has rejected your follow request!';
      }

      var response = {
        message: message,
        senderID: this.$store.getters.user.id,
        senderName: this.$store.getters.user.name,
        receiverID: notification.senderID,
        receiverName: notification.senderName,
        read: false,
        accepted: accepted,
        type: 'ContactResponse',
        timestamp: timestamp
      };

      var sender = {
        contactID: notification.senderID,
        contactName: notification.senderName,
        accepted: true,
        timestamp: timestamp
      };

      var receiver = {
        contactID: notification.receiverID,
        contactName: notification.receiverName,
        accepted: true,
        timestamp: timestamp
      };

      if (accepted) {
        this.$store.dispatch('addContact', { payload: sender, userID: notification.receiverID });
        this.$store.dispatch('addContact', { payload: receiver, userID: notification.senderID });
      } else {
        this.$store.dispatch('deleteContact', { account: notification.senderID, contact: notification.receiverID });
      }

      this.$store.dispatch('sendNotification', response);

      notification.message = 'You have a new contact: ' + notification.senderName;
      notification.accepted = true;
      notification.read = true;
      notification.timestamp = new Date().getTime();
      notification.type = 'ContactSuccess';

      this.$store.dispatch('updateNotification', notification);
    }
  },
  created: function created() {
    console.log(this.$parent);
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "chat",
    attrs: {
      "color": "secondary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Notifications")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.sortedNotifications), function(notification) {
    return [_c('v-list-tile', {
      key: notification.id,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s((notification.read) ? notification.message : notification.message.bold())
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s((notification.read) ? new Date(notification.timestamp).toLocaleString() + ' - Seen' : new Date(notification.timestamp).toLocaleString())
      }
    }), _vm._v(" "), _c('v-card-actions', [(notification.type == 'ContactRequest') ? _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.respond(notification, true)
        }
      }
    }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (notification.type == 'ContactRequest') ? _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.respond(notification, false)
        }
      }
    }, [_vm._v("Reject")]) : _vm._e()], 1)], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Search: ")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredUsers,
      "box": "",
      "chips": "",
      "color": "secondary",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return undefined
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-avatar', [_c('img', {
          attrs: {
            "src": data.item.photoURL
          }
        })]), _vm._v(" "), _c('v-list-tile-content', {
          on: {
            "click": function($event) {
              _vm.pushProfile(data.item.id)
            }
          }
        }, [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _vm._v(" "), _c('v-list-tile-sub-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.group)
          }
        })], 1)]]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Messages_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Messages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Messages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Contacts_Search_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Contacts_Search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Contacts_Search_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import Vue from 'vue'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {},
      isContact: false,
      isPending: false,
      emails: '',
      contacts: [],
      showContacts: false,
      showSearch: false,
      messagesShowing: false,
      dialog: false,
      notifications: [],
      inviteDiag: false,
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
        );
      }],
      emailValid: false
    };
  },

  components: {
    vMessages: __WEBPACK_IMPORTED_MODULE_1__Messages_vue___default.a,
    vSearch: __WEBPACK_IMPORTED_MODULE_2__Contacts_Search_vue___default.a
  },
  computed: {
    isCurrentUser: function isCurrentUser() {
      return this.$store.getters.user.id === this.$route.params.id;
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'reset',
    messagesShowing: 'readMessages'
  },
  validations: {
    emails: { email: this.emailRules }
  },
  methods: {
    readMessages: function readMessages() {
      if (!this.messagesShowing) {
        this.$refs.messages.readMessages();
      }
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.emailValid = re.test(email);
    },
    invite: function invite() {
      if (this.emails !== null && this.emails !== '') {
        this.validateEmail(this.emails);
        if (this.emailValid) {
          this.inviteDiag = false;
          alert('Form submitted');
          // send email
          this.emails = '';
        }
      }
    },
    close: function close() {
      this.inviteDiag = false;
      this.emails = '';
    },
    reset: function reset() {
      this.user = {};
      this.isContact = false;
      this.isPending = false;
      this.contacts = [];
      this.showContacts = false;
      this.showSearch = false;
      this.emails = '';
      this.emailValid = false;
      this.messagesShowing = false;
      this.dialog = false;
      this.inviteDiag = false;
      this.notifications = [];
      this.pullFromDatabase();
    },
    connect: function connect() {
      var timestamp = new Date().getTime();
      var notification = {
        message: this.$store.getters.user.name + ' would like to connect with you!',
        senderID: this.$store.getters.user.id,
        senderName: this.$store.getters.user.name,
        receiverID: this.user.id,
        receiverName: this.user.name,
        read: false,
        accepted: null,
        type: 'ContactRequest',
        timestamp: timestamp
      };
      var contact = {
        contactID: this.user.id,
        contactName: this.user.name,
        accepted: false,
        timestamp: timestamp
      };
      this.$store.dispatch('sendNotification', notification);
      this.$store.dispatch('addContact', { payload: contact, userID: this.$store.getters.user.id });
      this.isContact = true;
      this.isPending = true;
    },
    toggleShowContacts: function toggleShowContacts() {
      this.showContacts = !this.showContacts;
    },
    pullFromDatabase: function pullFromDatabase() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$route.params.id).get().then(function (doc) {
        var user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'title': doc.data().title,
          'organization': doc.data().organization
        };
        _this.user = user;
        _this.dialog = (_this.user.name == null || _this.user.bio == null) && _this.user.id === _this.$store.getters.user.id;
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(_this.user.id).collection('contacts').where('accepted', '==', true).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            _this.contacts.push(doc.data());
          });
        }).catch(function (error) {
          console.log('Error getting documents: ', error);
        });
      });

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('contacts').where('contactID', '==', this.$route.params.id).get().then(function (querySnapshot) {
        if (querySnapshot.size !== 0) {
          _this.isContact = true;
          _this.isPending = !querySnapshot.docs[0].data().accepted;
        }
      }).catch(function (error) {
        console.log('Error getting documents: ', error);
      });

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('notifications')
      // .where('read', '==', false)
      .get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var notification = doc.data();
          notification.id = doc.id;
          _this.notifications.push(notification);
        });
      }).catch(function (error) {
        console.log('Error getting documents: ', error);
      });
    }
  },
  created: function created() {
    this.pullFromDatabase();
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          Welcome to Insider\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Please add a name and biography to your profile so that your contacts can search and connect with you easier. \n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "to": "/editprofile"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("\n            Edit Profile\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCurrentUser),
      expression: "isCurrentUser"
    }],
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.messagesShowing = !_vm.messagesShowing
      }
    },
    slot: "activator"
  }, [_c('v-badge', {
    attrs: {
      "right": ""
    }
  }, [(_vm.notifications.filter(function (notification) { return !notification.read; }).length > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.notifications.filter(function (notification) { return !notification.read; }).length))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("message")])], 1)], 1), _vm._v(" "), _c('v-messages', {
    ref: "messages",
    attrs: {
      "notifications": _vm.notifications
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": _vm.toggleShowContacts
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("people")])], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contacts.length > 0),
      expression: "contacts.length > 0"
    }]
  }, [_vm._l((_vm.contacts), function(contact, index) {
    return _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          _vm.$router.push('/profile/' + contact.contactID)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(contact.contactName))])], 1)
  }), _vm._v(" "), _c('v-list-tile')], 2), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showSearch),
      callback: function($$v) {
        _vm.showSearch = $$v
      },
      expression: "showSearch"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n            Find New Contacts \n            "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-search')], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCurrentUser),
      expression: "isCurrentUser"
    }],
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "to": "/editprofile"
    }
  }, [_c('v-list-tile-title', [_vm._v("Edit Profile")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('br'), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "text-md-center"
  }, [_c('v-avatar', {
    attrs: {
      "size": "140"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.photoURL,
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-md-center"
  }, [(_vm.user.title != null) ? _c('p', [_vm._v(" Job Title: " + _vm._s(_vm.user.title))]) : _vm._e(), _vm._v(" "), (_vm.user.organization != null) ? _c('p', [_vm._v(" Organization: " + _vm._s(_vm.user.organization))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(" About Me ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.bio))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.inviteDiag),
      callback: function($$v) {
        _vm.inviteDiag = $$v
      },
      expression: "inviteDiag"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "slot": "activator",
      "round": ""
    },
    slot: "activator"
  }, [_vm._v(" Invite Friends")]), _vm._v(" "), _c('v-card', {
    staticClass: "white",
    attrs: {
      "height": "300",
      "width": "500"
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('h1', [_vm._v("Invite Friends")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-text-field', {
    staticClass: "primary",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "text",
      "required": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.invite()
      }
    }
  }, [_vm._v(" Invite ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-md-center"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentUser && !_vm.isContact),
      expression: "!isCurrentUser && !isContact"
    }],
    attrs: {
      "round": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.connect
    }
  }, [_vm._v("Connect With " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPending),
      expression: "isPending"
    }],
    attrs: {
      "round": "",
      "disabled": ""
    }
  }, [_vm._v(" You have requested to connect with " + _vm._s(_vm.user.name) + " ")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isContact && !_vm.isPending),
      expression: "isContact && !isPending"
    }],
    attrs: {
      "round": "",
      "disabled": ""
    }
  }, [_vm._v(" You are connected with " + _vm._s(_vm.user.name) + " ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.3e29b43f882380441773.js